export const defaultDateFormat = 'MM/DD/YYYY';
export const monthYearDateFormat = 'MMMM YYYY';
export const textMonthDateFormat = 'MMMM DD YYYY';
export const dayTextMonthDateFormat = 'D MMMM YYYY';
export const backendDateFormat = 'YYYY-MM-DD';

export function subtractYears(date, years) {
  return new Date().setFullYear(date.getFullYear() - years);
}
